package co.maytes.standupbot.dashboard.features.settings

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.components.widgets.IconButton
import co.maytes.standupbot.dashboard.components.widgets.TextInput
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideEye
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideEyeOff
import co.maytes.standupbot.dashboard.styles.Spacing
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier
import org.jetbrains.compose.web.attributes.InputType

@Composable
fun IntegrationsSecretInput(
    value: String,
    onValueChange: (String) -> Unit,
    label: String,
    modifier: Modifier = Modifier,
    placeholder: String = "",
) {
    var revealed by remember { mutableStateOf(false) }
    Row(
        modifier = modifier.styleModifier {
            property("min-width", "0")
            property("gap", Spacing.xs.toString())
        },
        verticalAlignment = Alignment.CenterVertically,
    ) {
        TextInput(
            value = value,
            onValueChange = onValueChange,
            modifier = Modifier.styleModifier {
                property("flex", "1 1 auto")
                property("min-width", "0")
            },
            placeholder = placeholder,
            type = if (revealed) InputType.Text else InputType.Password,
            ariaLabel = label,
            clearable = false,
        )
        IconButton(
            ariaLabel = if (revealed) "Hide $label" else "Show $label",
            onClick = { revealed = !revealed },
        ) {
            if (revealed) LucideEyeOff(size = EYE_SIZE) else LucideEye(size = EYE_SIZE)
        }
    }
}

private const val EYE_SIZE = 14
